module.exports = __webpack_public_path__ + "img/蛋白轻医美.0fa50d2.png";